import { useGenGridCol } from "src/utils/HelperComp";
import { TableColumnKey } from "../../../types/Table";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import useCopyableCell from "./useCopyableCell";
import useOperationCell from "./useOperationCell";

const useTableColumns = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { renderOperationCell, renderDialogInOperationCell } =
    useOperationCell();
  const { renderCopyableCell } = useCopyableCell();

  const renderDialogInTableRow = () => {
    return <>{renderDialogInOperationCell()}</>;
  };

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationCell,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(TableColumnKey.RiskType, t(TableColumnKey.RiskType)),
    useGenGridCol(TableColumnKey.Status, t(TableColumnKey.Status)),
    useGenGridCol(
      TableColumnKey.WalletDisplayName,
      t(TableColumnKey.WalletDisplayName),
      {
        minWidth: 290,
      },
    ),
    useGenGridCol(
      TableColumnKey.RecipientAddress,
      t(TableColumnKey.RecipientAddress),
      {
        renderCell: renderCopyableCell("recipientAddress"),
        minWidth: 300,
      },
    ),
    useGenGridCol(TableColumnKey.WalletType, t(TableColumnKey.WalletType), {
      minWidth: 180,
    }),
    useGenGridCol(TableColumnKey.Rating, t(TableColumnKey.Rating)),
    useGenGridCol(TableColumnKey.Probability, t(TableColumnKey.Probability)),
  ];
  return { columns, renderDialogInTableRow };
};

export default useTableColumns;
